import React, { useEffect, useState } from 'react';
import { api } from '../api.js';
import { useAuth } from '../auth.jsx';
import { useI18n } from '../i18n/index.jsx';

// Online dot / "Vu il y a 5 min" (migration 027). Nothing is shown when the
// member hides their status, or when the viewer hides their own.
export function lastSeenText(iso, t, lang) {
  if (!iso) return '';
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  const rtf = new Intl.RelativeTimeFormat(lang === 'en' ? 'en' : 'fr', { numeric: 'auto', style: 'short' });
  const v = s < 3600 ? rtf.format(-Math.max(1, Math.round(s / 60)), 'minute') : s < 86400 ? rtf.format(-Math.round(s / 3600), 'hour') : rtf.format(-Math.round(s / 86400), 'day');
  return t('presence.lastSeen', { when: v });
}
export function Dot({ status }) {
  const { t, lang } = useI18n();
  if (!status) return null;
  const label = status.online ? t('presence.online') : lastSeenText(status.lastSeen, t, lang) || t('presence.offline');
  return <span className={`presence-dot${status.online ? ' is-online' : ''}`} role="img" aria-label={label} title={label} />;
}
export function StatusText({ status }) {
  const { t, lang } = useI18n();
  if (!status) return null;
  return <span className={`presence-text${status.online ? ' is-online' : ''}`}>{status.online ? t('presence.online') : lastSeenText(status.lastSeen, t, lang)}</span>;
}

// Status by company page address (product page / company page), refreshed
// every minute while shown. Signed-in members only.
export function useSlugPresence(slug) {
  const { user } = useAuth();
  const [st, setSt] = useState(null);
  useEffect(() => {
    if (!user || !slug) return undefined;
    let alive = true;
    const load = () => api(`/chat/presence?slugs=${encodeURIComponent(slug)}`).then((r) => { if (alive) setSt(r.bySlug[slug] || null); }).catch(() => {});
    load();
    const tm = setInterval(load, 60 * 1000);
    return () => { alive = false; clearInterval(tm); };
  }, [user, slug]);
  return st;
}
